export enum DRUG_TOGGLE_OPTIONS {
  MAIL_ORDER = 'mailOrder',
  RETAIL = 'retail'
}
